import styles from '../../../styles/mission.module.css';
import mission from '../../../images/mission.jpg';
import { Link } from 'react-router-dom';

const Mission = () => {
    return ( 
        <>
        <div className={styles.missionwrapper}>
            <img src={mission} alt="mission" className={styles.missionimg1} />
            <div className={styles.missiontext}>
                <h2>Our Mission</h2>
                            <img src={mission} alt="mission" className={styles.missionimg2} />
                <p>To provide quality education and foster holistic development of every student. Our commitment is to create an environment where students can thrive academically, socially, and emotionally. We believe in nurturing the whole child and preparing them for success in their future endeavors.   </p>
                                <p>To provide quality education and foster holistic development of every student. Our commitment is to create an environment where students can thrive academically, socially, and emotionally. We believe in nurturing the whole child and preparing them for success in their future endeavors.   </p>

                <Link to="/projects"  style={{ textDecoration: "none" }}>
          
                <button className={styles.btn}>
                    Explore Projects
                    
                              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-building-check" viewBox="0 0 16 16">
  <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514"/>
  <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1z"/>
  <path d="M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
</svg>

                    </button>
                    </Link>

            </div>
        </div>
        </>

     );
}
 
export default Mission;
